import { ProductBreadcrumb, ProductSelectedInfo, CartButtonConfig } from '../product.types';
import { ISwatchConfig } from 'components/Catalog/Product/Configurator';
import { IFinanceResponse } from 'components/Financing/Interfaces/IFinance';
import { IAvailabilityResponse } from 'components/Catalog/Product/Interfaces/IAvailability';
import { IBuyBackConfig } from 'components/BuyBack/interfaces/buyBackInterfaces';
import { IRequiredProduct } from 'components/Cart/Interfaces/ICartProduct';

export enum ProductType {
    SIMPLE_PRODUCT_TYPE = 'simple',
}

export interface IProductInterestConfig {
    title: string;
    description: string;
    iframe: string;
}

export interface IConfigPrice {
    value: number;
    label: string;
    valueLabel: string;
}

export interface IRequiredProductsPrice {
    products?: IRequiredProduct[];
    priceWithRequiredLabel?: string;
    priceWithRequired?: string;
}

export interface ISmartdealB2BConfig {
    enabled: boolean;
    url?: string;
    imageUrl?: string;
    labels: {
        pay: string;
        smartdealBusiness: string;
    };
}

export interface IProductConfig {
    name: string;
    type: string;
    price: IConfigPrice;
    id: string;
    sku: {
        label: string;
        value: string;
    };
    shortDescription?: string;
    description?: string;
    priceFormat: string;
    successFormat: string;
    preTitle?: string;
    itemBrand?: string;
    priceOld?: string;
    addToCartButton: CartButtonConfig;
    productNuggets?: string;
    notAvailableLabel?: string;
    eolHtml?: string;
    isConfigurableProduct?: string;
    breadcrumbs: {
        [key: string]: ProductBreadcrumb[];
    };
    category?: string;
}

export interface IDetailViewConfig {
    swatchConfig: ISwatchConfig;
    productConfig: IProductConfig;
    labels: {
        lookTechData: string;
        productName?: string;
        brand?: string;
        showMore?: string;
        showLess?: string;
        descriptionTitle?: string;
    };
    financialConfig: IFinanceResponse;
    availabilityConfig?: {
        availabilityLabel: string;
        items: IAvailabilityResponse[];
    };
    inbankRentalConfig?: {
        monthlyFee: {
            label: string;
            value: string;
        };
        aboutInbankRental: string;
        chooseRenewalPeriodLabel: string;
        inbankRentalTermsUrl: string;
        inbankRentalLabels: string[];
        extraInfo: string;
        useInsuranceLabel: string;
    };
    inbankRentalEnabled: boolean;
    slice3MethodEnabled: boolean;
    smartdealB2BConfig: ISmartdealB2BConfig;
    buyBackConfig: IBuyBackConfig;
}

// Type aliases for backward compatibility
export type ISelectedProductInformation = ProductSelectedInfo;
export type ICartButtonConfig = CartButtonConfig;
export type IDetailProductBreadcrumb = ProductBreadcrumb;
